import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MessageService {
  private subject = new Subject<unknown>();
  private pricing = new Subject<unknown>();
  private attachments = new Subject<unknown>();

  sendMessage(message: object) {
    this.subject.next(message);
  }

  clearMessage() {
    // this.subject.next(); -- No argument passed
  }

  getMessage(): Observable<unknown> {
    return this.subject.asObservable();
  }

  setPricingObj(obj: unknown){
    this.pricing.next(obj);
  }

  getPricing(){
    return this.pricing.asObservable();
  }

  setAttachments(arr: unknown){
    this.attachments.next(arr);
  }

  getAttachments(){
    return this.attachments.asObservable();
  }
}
